var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"illustration",class:_vm.name},[_c('figure',{staticClass:"illustration__image",style:({'background-image': _vm.illustrationUrl})})])
}
var staticRenderFns = []

export { render, staticRenderFns }